export const BatchTicketStatus = {
  None: 'None',
  Created: 'Created',
  Started: 'Started',
  Batched: 'Batched',
};
